var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewGrades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4697 1.19971C15.8696 0.809794 16.4996 0.79998 16.8896 1.19971L18.2998 2.60986C18.6898 2.99986 18.6898 3.63002 18.2998 4.02002L14 8.32959V17.9995H3V2.99951H13.6699L15.4697 1.19971ZM6.57227 11.8003L5.03613 15.9995H6.11621L6.41016 15.1597H8.37305L8.67188 15.9995H9.75195L8.22754 11.8003H6.57227ZM11.0537 12.3696V13.4321H10.0273V14.3735H11.0537V15.4302H12.0615V14.3735H13.0869V13.4321H12.0615V12.3696H11.0537ZM7.49023 12.6763L8.06152 14.2837H6.7168L7.28027 12.6763H7.49023ZM9.82031 8.27002L9.11035 10.3901L11.2305 9.68018L16.5996 4.31982L15.1797 2.8999L9.82031 8.27002Z",
    fill: "#BF6C58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewGrades);
export default __webpack_public_path__ + "static/media/view-grades.e5aa7bacf627b7f4e3221fc877281d46.svg";
export { ForwardRef as ReactComponent };